import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
export function getMultiSectionDigitalClockUtilityClass(slot) {
  return generateUtilityClass('MuiMultiSectionDigitalClock', slot);
}
export var multiSectionDigitalClockClasses = generateUtilityClasses('MuiMultiSectionDigitalClock', ['root']);